<div class="outer" [ngStyle]="{'min-height': height || null, 'padding': padding || null, 'background-color': color?.hex, 'color' : color?.text, 'background-image': (image ? ('url(\''+ image + '\')') : null)}">

    <div class="inner">
        <ng-content></ng-content>
    </div>

</div>